import { render, staticRenderFns } from "./ProjectUserStoryDescriptionTextarea.vue?vue&type=template&id=6f60da63&scoped=true&"
import script from "./ProjectUserStoryDescriptionTextarea.vue?vue&type=script&lang=js&"
export * from "./ProjectUserStoryDescriptionTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f60da63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTextarea,VTooltip})
